const keys = {
  COMPRADOR_NOVA_REQUISICAO: {
    key: 'COMPRADOR_NOVA_REQUISICAO',
    description: 'Receber notificação quando uma nova solicitação de compra é criada.',
    userRoles: ['ROLE_COMPRADOR'],
    defaultEmailEnabledValue: true,
    defaultWhatsappEnabledValue: true,
  },
  REQUISICAO_FINALIZADA: {
    key: 'REQUISICAO_FINALIZADA',
    description: 'Receber notificação sobre a finalização dos itens solicitados.',
    userRoles: ['ROLE_REQUISICAO'],
    defaultEmailEnabledValue: true,
    defaultWhatsappEnabledValue: true,
  },
  REQUISICAO_ATUALIZADA: {
    key: 'REQUISICAO_ATUALIZADA',
    description: 'Receber notificação quando uma solicitação de compra é editada.',
    userRoles: ['ROLE_COMPRADOR'],
    defaultEmailEnabledValue: true,
    defaultWhatsappEnabledValue: true,
  },
  COMPRA_RECUSADA_PELO_FORNECEDOR_GESTAO: {
    key: 'COMPRA_RECUSADA_PELO_FORNECEDOR_GESTAO',
    description: 'Receber notificação quando o fornecedor recusa o pedido de compra.',
    userRoles: ['ROLE_COMPRADOR'],
    defaultEmailEnabledValue: true,
    defaultWhatsappEnabledValue: true,
  },
  NOTIFICAR_APROVADOR_NOVA_REQUISICAO: {
    key: 'NOTIFICAR_APROVADOR_NOVA_REQUISICAO',
    description: 'Receber notificação quando uma nova aprovação de solicitação de compra é criada.',
    userRoles: ['ROLE_APROVADOR_REQUISICAO'],
    defaultEmailEnabledValue: true,
    defaultWhatsappEnabledValue: true,
  },
  NOTIFICAR_SOLICITANTE_ITENS_FINALIZADOS: {
    key: 'NOTIFICAR_SOLICITANTE_ITENS_FINALIZADOS',
    description: 'Receber notificação quando os itens da aprovação de solicitação de compra forem finalizados (Aprovados ou recusados).',
    userRoles: ['ROLE_REQUISICAO'],
    defaultEmailEnabledValue: true,
    defaultWhatsappEnabledValue: true,
  },
  NOTIFICAR_APROVADOR_NOVA_COMPRA: {
    key: 'NOTIFICAR_APROVADOR_NOVA_COMPRA',
    description: 'Receber notificação quando uma nova aprovação de compra é criada.',
    userRoles: ['ROLE_APROVADOR_COMPRAS'],
    defaultEmailEnabledValue: true,
    defaultWhatsappEnabledValue: true,
  },
  NOTIFICAR_COMPRADOR_ITENS_FINALIZADOS: {
    key: 'NOTIFICAR_COMPRADOR_ITENS_FINALIZADOS',
    description: 'Receber notificação quando os itens da aprovação de compra forem finalizados (Aprovados ou recusados).',
    userRoles: ['ROLE_COMPRADOR'],
    defaultEmailEnabledValue: true,
    defaultWhatsappEnabledValue: true,
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
